import { PriceActionFilters } from '@/types/common.types';
import { FilterOptions, PriceComparisonData } from '@/types/price-comparison.types';
import { ApiResponse } from '@/types/services';

import { apiService, downloadBlob } from './api';
import { baseApi } from './base-api';
import { buildQueryParams } from './helpers';

export type GetPriceComparisonFiltersResponse = ApiResponse<FilterOptions>;
export type GetPriceComparisonDataResponse = ApiResponse<PriceComparisonData>;

export const priceComparisonApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getPriceComparisonFilters: builder.query<FilterOptions, PriceActionFilters>({
      query: filters => {
        const queryString = buildQueryParams(filters);
        return { url: `price-comparison/filters${queryString ? `?${queryString}` : ''}` };
      },
      providesTags: ['ProceComparissonFilters'],
      transformResponse: (response: GetPriceComparisonFiltersResponse): FilterOptions => {
        return response.data;
      }
    }),
    getPriceComparisonData: builder.query<PriceComparisonData, PriceActionFilters>({
      query: filters => {
        const queryString = buildQueryParams(filters);
        return { url: `price-comparison/data${queryString ? `?${queryString}` : ''}` };
      },
      providesTags: ['ProceComparissonFilters'],
      transformResponse: (response: GetPriceComparisonDataResponse): PriceComparisonData => {
        return {
          brand_summary: response.data.brand_summary || [],
          fuel_types: response.data.fuel_types || [],
          station_details: response.data.station_details || [],
          performanceStatus: response.data.performanceStatus
        };
      }
    }),

    exportPriceComparisonToExcel: builder.mutation<boolean, PriceActionFilters>({
      async queryFn(filters = {}) {
        try {
          const queryString = buildQueryParams(filters);

          const { blob, filename } = await apiService.getBlob(
            `/price-comparison/export${queryString ? `?${queryString}` : ''}`
          );

          downloadBlob(blob, filename);

          return { data: true };
        } catch (error) {
          return { error: error as any };
        }
      }
    })
  })
});
export const {
  useGetPriceComparisonFiltersQuery,
  useGetPriceComparisonDataQuery,
  useExportPriceComparisonToExcelMutation
} = priceComparisonApi;
